import * as React from "react"
const SvgStarCircle = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12 15.664 2.775 2.1q.3.2.6.013t.175-.538l-1.05-3.475 2.725-1.95q.3-.225.175-.562t-.475-.338H13.6l-1.125-3.65q-.125-.35-.475-.35t-.475.35l-1.125 3.65H7.075q-.35 0-.475.338-.125.337.175.562l2.725 1.95-1.05 3.475q-.125.35.175.538.3.187.6-.013zm0 7.05a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9 9.7 9.7 0 0 1 .788-3.9A10.1 10.1 0 0 1 4.925 5.64Q6.275 4.29 8.1 3.503a9.7 9.7 0 0 1 3.9-.788 9.7 9.7 0 0 1 3.9.788 10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.138a9.7 9.7 0 0 1-3.9.787Zm0-2q3.325 0 5.663-2.337 2.336-2.338 2.337-5.663 0-3.325-2.337-5.662Q15.325 4.714 12 4.714c-3.325 0-4.104.78-5.662 2.338Q4 9.39 4 12.714q0 3.325 2.338 5.663T12 20.714" />
  </svg>
)
export default SvgStarCircle
